import React, { useState, useEffect } from "react";
import './index.scss';

const Tab = ({ data = [], onChange, activeClass }) => {
  const [active, setActive] = useState(0);
  const change = (index) => {
    setActive(index);
    onChange(index);
  }
  return <div className="tab_container">
    {data && data.map((item, index) => {
      return <span key={index} onClick={() => { change(index) }} className={`${active == index ? `tab_item_active ${activeClass}` : ''}`}>{item}</span>
    })}
  </div>
}

export default Tab;